// extracted by mini-css-extract-plugin
export default {"span":"mimic___styles_span__BA3TL"};